import React from 'react';

const events = [
  { date: 'May 15', year: '2026', title: 'Annual Health Symposium', location: 'Main Auditorium', type: 'upcoming', desc: 'National conference on modern nursing practices with keynote speakers from top hospitals.' },
  { date: 'Apr 20', year: '2026', title: 'Blood Donation Camp', location: 'College Campus', type: 'upcoming', desc: 'Community service event in collaboration with City Red Cross Society.' },
  { date: 'Mar 10', year: '2026', title: 'Clinical Skills Workshop', location: 'Simulation Lab', type: 'past', desc: 'Hands-on training in advanced life support and emergency care techniques.' },
  { date: 'Feb 05', year: '2026', title: 'Alumni Meet & Career Fair', location: 'Conference Hall', type: 'past', desc: 'Networking event featuring 50+ healthcare recruiters and successful alumni.' },
];

function Events() {
  return (
    <section id="events" className="events-section">
      <div className="section-container">
        <h2 className="section-title"><span className="title-icon">📅</span> Events & Activities</h2>
        <div className="events-grid">
          {events.map((event, i) => (
            <div key={i} className={`event-card ${event.type}`}>
              <div className="event-date-badge">
                <span className="event-day">{event.date.split(' ')[0]}</span>
                <span className="event-month">{event.date.split(' ')[1]}</span>
                <span className="event-year">{event.year}</span>
              </div>
              <div className="event-details">
                <h4>{event.title}</h4>
                <p className="event-location">📍 {event.location}</p>
                <p className="event-desc">{event.desc}</p>
                <button className="btn btn-small btn-primary">
                  {event.type === 'upcoming' ? 'Register Now' : 'View Recap'}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Events;